import { graphql } from 'gql.tada';

export const GET_CART = graphql(`
    query cart {
        cart {
            identifier {
                id
            }
            total
            programs {
                language
                program {
                    identifier {
                        id
                    }
                    titles
                    coverUrl
                    creditRollUrl
                    duration
                    audioLanguages
                    masterSubtitles {
                        language
                    }
                    price
                    firstBroadcastDate
                    parent {
                        identifier {
                            id
                        }
                        titles
                    }
                    episodeNumber
                    episodesQuantity
                    seller {
                        legalName
                    }
                }
            }
        }
    }
`);

export const ADD_TO_CART = graphql(`
    mutation addToCart($input: AddToCartInput!) {
        cart {
            billing {
                addToCart(input: $input) {
                    identifier {
                        id
                    }
                    total
                    programs {
                        language
                        program {
                            identifier {
                                id
                            }
                            titles
                            coverUrl
                            creditRollUrl
                            duration
                            audioLanguages
                            masterSubtitles {
                                language
                            }
                            price
                            firstBroadcastDate
                            parent {
                                identifier {
                                    id
                                }
                                titles
                            }
                            episodeNumber
                            episodesQuantity
                            seller {
                                legalName
                            }
                        }
                    }
                }
            }
        }
    }
`);

export const REMOVE_FROM_CART = graphql(`
    mutation removeFromCart($input: RemoveFromCartInput!) {
        cart {
            billing {
                removeFromCart(input: $input) {
                    identifier {
                        id
                    }
                    total
                    programs {
                        language
                        program {
                            identifier {
                                id
                            }
                            titles
                            coverUrl
                            creditRollUrl
                            duration
                            audioLanguages
                            masterSubtitles {
                                language
                            }
                            price
                            firstBroadcastDate
                            parent {
                                identifier {
                                    id
                                }
                                titles
                            }
                            episodeNumber
                            episodesQuantity
                            seller {
                                legalName
                            }
                        }
                    }
                }
            }
        }
    }
`);

export const UPDATE_CART = graphql(`
    mutation updateCart($input: UpdateCartInput!) {
        cart {
            billing {
                updateCart(input: $input) {
                    identifier {
                        id
                    }
                    total
                    programs {
                        language
                        program {
                            identifier {
                                id
                            }
                            titles
                            coverUrl
                            creditRollUrl
                            duration
                            audioLanguages
                            masterSubtitles {
                                language
                            }
                            price
                            firstBroadcastDate
                            parent {
                                identifier {
                                    id
                                }
                                titles
                            }
                            episodeNumber
                            episodesQuantity
                            seller {
                                legalName
                            }
                        }
                    }
                }
            }
        }
    }
`);
